import { render } from "./ContactContent.vue?vue&type=template&id=35b734de&scoped=true&lang=html"
import script from "./ContactContent.vue?vue&type=script&lang=js"
export * from "./ContactContent.vue?vue&type=script&lang=js"

import "./ContactContent.vue?vue&type=style&index=0&id=35b734de&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-35b734de"

export default script